import WithdrawalTable from "./withdrawalTable"

export default function Withdrawal() {
  return (
    <>
      <WithdrawalTable />
    </>
  )
}
